import { Helper } from '../../Helper';
export class SetArrayIndexHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitOp(node, 'ROT');
        sb.emitHelper(node, options, sb.helpers.unwrapArray);
        sb.emitPushInt(node, 3);
        sb.emitOp(node, 'XTUCK');
        sb.emitPushInt(node, 2);
        sb.emitOp(node, 'PICK');
        sb.emitOp(node, 'INC');
        sb.emitHelper(node, options, sb.helpers.extendArr);
        sb.emitOp(node, 'SETITEM');
    }
}

//# sourceMappingURL=SetArrayIndexHelper.js.map
